import React from 'react';
import './statscard.css';

const Statscard = (props) => {
  return (
    <div className="stats_card">
      <div className="stats_card_label">{props.label}</div>

      <div className="stats_card_body">
        <div className="stats_card_meta">
          <div className="stats_card_value">{props.value}</div>
          <div className="stats_card_change">
            <div className="stats_card_change_icon">↗</div>
            <div>{props.change}</div>
          </div>
        </div>

        <div className="stats_card_icon">
          <img alt="" src={props.icon} />
        </div>
      </div>
    </div>
  );
};

export default Statscard;
